import { useEffect, useState } from "react";

// Return a debounced copy of `value` — updated only after `delay` ms of
// no changes. Perfect for search inputs so we don't re-query the
// backend on every keystroke.
export default function useDebouncedValue(value, delay = 250) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
